import has from 'lodash/has.js';

export default {
    /**
     * Creates and object of search parameters based on current state
     * @param  {object} state
     * @return {object}
     */
    searchParams(state) {
        const params = {};

        // Set Keyword
        if (state.keyword !== '') {
            params.keyword = state.keyword;
        }

        // Set any facets
        state.appliedFacets.forEach((facet) => {
            if (has(params, facet.type)) {
                params[facet.type].push(facet.value);
            } else {
                params[facet.type] = [facet.value];
            }
        });

        // Specifies a specific result type
        if (state.types.length) {
            params.mode = state.types;
        }

        if (state.showSaved) {
            params.mysaved = 1;
        }

        // Add a page query if not on requesting the first page
        if (state.currentPage !== 1) {
            params.page = state.currentPage;
        }
        return params;
    },
};
